import react, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import SharePopup from '../components/SharePopup';
import axios from 'axios';
import waIcon from '../assets/images/wa-icon.png'

const CampaignPopup = ({bank, campaign, exitFunction}) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [formStatus, setFormStatus] = useState('Submit');
    const [sharePopupActive, setSharePopup] = useState(false);
    const [shareActive, setShareState] = useState(false);
    const [isDropoff, setDropOff] = useState(false);
    const form = useRef();
    var inviteCount = 1;

    useEffect(() => {
        if (campaign.is_drop_off) {
            setDropOff(true);
        }
        console.log("CAMPAIGN: ")
        console.log(campaign)
    }, [campaign])

    const onSubmit = async (e) => {
        e.preventDefault();
        setFormStatus("Submitting...");
        const { name, email, phone, date, address, invitee } = e.target.elements;
        let campaignForm = {
            name: name.value ? name.value : "",
            email: email.value ? email.value : "",
            phone: phone.value ? phone.value : "",
            date: date ? date.value : "2025-01-01",
            address: address ? address.value : "",
            campaign: campaign.id,
            invitee: invitee.value ? invitee.value : ""
        }
        console.log(campaignForm)

        axios
            .post(`${apiUrl}/campaignmember/add-member`, campaignForm)
            .then((response) => {
                console.log(response);
                setShareState(true)
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error)
                }
                console.log(error)
                //alert("Submission failed, please try again");
                setShareState(true)
            })
    }

    const incrementShareCount = async () => {
        console.log("Increasing share count.");
        console.log(bank)
        var request = `${apiUrl}/bank/inc-share/${bank['bankId'] ? bank['bankId'] : bank.id}`;

        axios
            .get(request)
            .then((response) => {
                console.log(response);
                setShareState(true);
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error)
                }
                console.log(error)
                //alert("Share count update failed, please try again");
            })
    }

    return (
        <Container>
        <PopupContent>
            <CloseButton onClick={() => {exitFunction(false)}}>X</CloseButton>
            <InfoBox>
                <SwirlContainer>
                    <Swirl src={require('../assets/images/hero-swirl.svg').default} />
                </SwirlContainer>
                
                <Title>Fundraising Campaign</Title>
                <Subtitle>You've been invited by {campaign ? campaign.name : "CAMPAIGN NOT FOUND"} to join their fundraising campain for {bank ? bank.name : "BANK NOT FOUND"}! 🎉</Subtitle>
                {isDropoff ? 
                    <>
                        <Subtitle>📅 Drop-off Date: {campaign ? campaign.date : "CAMPAIGN NOT FOUND"}</Subtitle>
                        <Subtitle>📍 Drop-off Address: <br /><span>{campaign ? campaign.address : "Fundraise & Recycle\n17 Pease Road\nPeterlee\nSR8 2RD"}</span></Subtitle>
                        <Subtitle>To support the campaign, simply clear out your wardrobes and drop off any clothes, shoes, handbags, gift sets, or jewelry you no longer need at  to {campaign ? campaign.address : "Fundraise & Recycle\n17 Pease Road\nPeterlee\nSR8 2RD"}, before the collection date.</Subtitle>
                        <Subtitle>Your contributions will help the organisation reach their fundraising goals while supporting a great cause. Let’s make a difference together!</Subtitle>
                    </> :
                    <>
                        <Subtitle>📅 Campaign Closing Date: {campaign ? campaign.date : "CAMPAIGN NOT FOUND"}</Subtitle>
                        <Subtitle>To support the campaign, simply clear out your wardrobes and bag up any clothes, shoes, handbags, gift sets, or jewelry you no longer need. Leave the bags outside your home before the campaign closing date for collection.</Subtitle>
                        <Subtitle>After submitting, Fundraise & Recycle will contact you to arrange a collection date that suits you.</Subtitle>
                        <Subtitle>Your contributions will help the organisation reach their fundraising goals while supporting a great cause. Let’s make a difference together!</Subtitle>
                    </>
                }
            </InfoBox>
            
            {!shareActive ?
                <Form ref={form} onSubmit={onSubmit} className="sponsor-form" noValidate>
                    <div className="form-field-container">
                        <label className="form-label" htmlFor="name">Full Name</label>
                        <input className="form-control" name="name" type="text" id="name" placeholder='e.g. Sarah Johnson' required />
                    </div>
                    <div className="form-field-container">
                        <label className="form-label" htmlFor="email">Email Address</label>
                        <input className="form-control" name="email" type="text" id="email" placeholder='e.g. SarahJohnson@gmail.com' required />
                    </div>
                    <div className="form-field-container">
                        <label className="form-label" htmlFor="phone">Contact Number</label>
                        <input className="form-control" name="phone" type="text" id="phone" placeholder='e.g. +44 7123 456789' required />
                    </div>
                    {!isDropoff ? 
                    <>
                    <div className="form-field-container vertical">
                        <label className="form-label" htmlFor="address"> Collection Address</label>
                        <input type="text" className="form-control" placeholder='Door Number, Street, Post Code' name="address" id="address" />
                    </div>
                    <div className="form-field-container vertical">
                        <label className="form-label" htmlFor="date">Collection Date</label>
                        <input className="form-control" name="date" type="date" id="date" />
                    </div>
                    </> : <></>
                    }
                    <DarkSubtitle>Invite others to join this campaign:</DarkSubtitle>
                    <div className="form-field-container">
                        <label className="form-label" htmlFor="invitee">Separate email addresses with spaces or commas</label>
                        <input className="form-control" name="email" type="text" id={`invitee`} placeholder="e.g. SarahJohnson@gmail.com" required />
                    </div>
                    <div className="form-field-container checkbox wa">
                        <label className="form-label" htmlFor="wa-button">Need help? Chat with us on Whatsapp</label>
                        <a href="https://wa.me/447453958291" target="_blank" className="form-control" type="checkbox" id="wa-button"><img src={waIcon} alt="WhatsApp Button" /></a>
                    </div>
                    <div className="form-field-container checkbox">
                        <label className="form-label" htmlFor="mailTick"> Keep me updated with collection progress and fundraising tips</label>
                        <input className="form-control" type="checkbox" id="mailTick" defaultChecked />
                    </div>
                    <button className="btn btn-danger" type="submit">
                        {formStatus}
                    </button>
                </Form> :
                <>
                    <ShareDirectText>Share this link directly with everyone you want to join your campaign:</ShareDirectText>
                    <ShareDirectText><a>{window.location.href}</a></ShareDirectText>
                    <ShareButton className="cta-3" onClick={() => {
                        if (navigator.share) {
                            navigator.share({
                                title: window.title,
                                text: `Would you help me organise a clothes collection on behalf of ${bank ? bank.name : "this organisation"}?\n\nThey’re fundraising ${bank ? bank.goal : ","} and by recycling your unwanted clothes we can help them get a step closer.\n\nPlease accept my invite to join the campaign and then share this invitation with friends and family who would also like to support ${bank ? bank.name : "this organisation"}.\nThank you!`,
                                url: window.location.href,
                            })
                                .then(() => {
                                    console.log('Successful share')
                                    incrementShareCount()
                                })
                                
                                .catch((error) => console.log('Error sharing', error));
                        } else {
                            incrementShareCount();
                            setSharePopup(true);
                        }
                    }}>
                        <p>SHARE MY CAMPAIGN!</p>
                    </ShareButton>
                </>
                }
        </PopupContent>
        </Container>
    )
}

export default CampaignPopup

const InfoBox = styled.div`
    width: 100%;
    background: #0F678F;
    border-radius: 30px;
    padding: 30px 30px 50px 50px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    color: white;


    * {
        color: white;
    }

    @media (max-width: 1080px) {
        max-width: 100%;
    }

    @media (max-width: 530px) {
        padding: 20px;
    }

    ::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
`

export const SwirlContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

export const Swirl = styled.img`
    position: absolute;
    width: 150%;
    top: -185px;
    left: -190px;

    @media (max-width: 1080px) {
        min-width: 100%;
        min-height: 100%;;
        object-fit: cover;
        left: -10%;
        top: 10%;
    }
`


const Container = styled.div`
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;

    ::webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */

    .acceptbtn {
        margin-top: 20px;
        background: #ECB525;
    }
`

const PopupContent = styled.div`
    background: white;
    position: relative;
    margin: auto;
    max-width: 580px;
    border-radius: 18px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    overflow: scroll;

    ::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
    }

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
`

const CloseButton = styled.a`
    position: absolute;
    top: 32px;
    right: 32px;
    font-size: 32px;
    color: white;
    cursor: default;
    z-index: 999;
`

const Title = styled.h1`
    font-size: 48px;
    font-weight: 400;
    color: white;
    text-align: left;
    margin: 0;
    z-index: 5;

    @media (max-width: 530px) {
        font-size: 36px;
    }
`

const Subtitle = styled.h2`
    color: white;
    margin-bottom: 0;
    font-weight: normal;
    z-index: 5;
    font-size: 24px;

    @media (max-width: 530px) {
        font-size: 24px;
    }
`

const DarkSubtitle = styled.h2`
  color: rgb(0, 74, 113);
  margin-bottom: 0;
  font-weight: normal;
  z-index: 5;
  font-size: 32px;

  @media (max-width: 530px) {
    font-size: 24px;
  }
`


const ShareButton = styled.a`
    background: #BE3258;
    color: white;

    width: 200px;
    text-align: center;
    border-radius: 50px;

    p {
        color: white;
        font-weight: bold;
        padding: 0 20px;
    }

    :hover {
        text-decoration: underline;
        cursor: pointer;
    }
`

const Form = styled.form`
    box-sizing: border-box;
    margin: 24px auto 0 auto;
    max-width: 470px;
    width: 100%;
    padding: 0 24px 24px 24px;
    
    .form-field-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        margin-top: 12px;
    }

    .form-field-container.horizontal {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        label {
            margin: 0;
        }
    }

    input,
    textarea,
    select {
        box-sizing: border-box;
        width: 100%;
        padding: 12px;
        outline: 0;
        border: 0;
    }

    input,
    textarea {
        background: white;
        border-radius: 12px;
        border: 1px solid #004A71;
    }

    textarea::placeholder,
    input::placeholder {
        color: #75B3CE;
    }

    #adPhoto {
        padding: 0;
    }

    label, legend {
        color: #004A71;
        margin-bottom: 8px;
        font-size: 18px;
        box-sizing: border-box;
    }

    button {
        border: 0;
        padding: 8px 24px;
        border-radius: 30px;
        font-size: 22px;
        background: #EF3E3C;
        width: 100%;
        color: white;
        margin-top: 24px;
    }

    .form-field-container.checkbox {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }

    .form-field-container.checkbox label {
        order: 2;
        font-size: 18px;
        margin-left: 10px;
    }

    .form-field-container.checkbox input {
        order: 1;
    }

    #mailTick {
        appearance: none; /* Remove default checkbox styling */
        -webkit-appearance: none; /* Safari */
        -moz-appearance: none; /* Firefox */
        width: 28px;
        height: 28px;
        position: relative;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #mailTick:checked {
        background: #004A71;
    }

    #mailTick:checked::after {
        content: "✔";
        color: white;
        font-size: 16px;
        font-weight: normal;
    }

    .radio-block {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
    }

    .radio-block input {
        width: min-content;
        margin-right: 20px;
        margin-top: 6px;
    }

    fieldset {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border: 0;
        padding: 0;
        margin: 0;
        legend {
            padding: 0;
            float: left; 
        }
        input {
            display: none;
        }
    }   

    .toggle {
        box-sizing: border-box;
        display: flex; 
        flex-flow: row nowrap;
        justify-content: flex-start; 
        align-items: stretch;

        input + label {
            margin: 0; 
            padding: 8px 30px;
            border: solid 1px #004A71; 
            background-color: #FFF;
            font-size: 1rem; 
            line-height: 140%; 
            text-align: center;
            box-shadow: 0 0 0 rgba(255,255,255,0);
            transition: border-color .15s ease-out, 
                        color .25s ease-out, 
                        background-color .15s ease-out,
                        box-shadow .15s ease-out;
            
            &:first-of-type {
                border-radius: 12px 0 0 12px; 
                border-right: none;
            }
            &:last-of-type {
                border-radius: 0 12px 12px 0; 
                border-left: none;
            }
        }
        
        input:hover + label {
            border-color: #004A71;
        }

        input:checked + label {
            background-color: #004A71;
            color: #FFF;
            box-shadow: $activeShadow;
            border-color: #004A71;
            z-index: 1;
        }
    }

    @media (max-width: 500px) {
        .type-toggle {
        flex-direction: column;}
    }

    #wa-button {
        line-height: 0;
        margin: 0px 3px 6px 4px;
        cursor: pointer;
    }

    #wa-button img {
        width: 28px;
        height: 28px;
    }

    .wa {
        margin-top: 48px;
    }

    #wa-button {
        line-height: 0;
        margin: 0px 3px 6px 4px;
        cursor: pointer;
    }

    #wa-button img {
        width: 28px;
        height: 28px;
    }

    .wa {
        margin-top: 48px;
    }
`

const ShareDirectText = styled.p`

`